import React, {Component} from 'react';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import AlertsStore from '../reflux/stores/AlertsStore';

class Loading extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            dims: {}
        };

        this.updateDims = this.updateDims.bind(this);
        this.handleAlerts = this.handleAlerts.bind(this);
    }

    componentDidMount() {
        this.unsubscribe = AlertsStore.listen(this.handleAlerts);
        window.addEventListener('resize', this.updateDims);
    }


    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDims);
        this.unsubscribe();
    }

        /**
     * Handles all incoming alerts and displays a modal with the messages
     * 
     * @param {string} e The type of alert that is being sent.
     * @param {string} title The title for the modal
     * @param {any} messages the messages to be displayed as children of modal
     * 
     * @return {void}
     */
    handleAlerts(e, title, messages) {
        switch(e) {
            case 'startLoading':
                this.setState({loading: true});
                break;
            case 'stopLoading':
                this.setState({loading: false});
                break;
            
        }
    }

    _getWindowDimensions() {
        let w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0],
        x = w.innerWidth || e.clientWidth || g.clientWidth,
        y = w.innerHeight|| e.clientHeight|| g.clientHeight;

        return {x, y};
    }

    updateDims() {           
        const dims = this._getWindowDimensions();
        this.setState({dims});
    }

    render() {
        const dims = this._getWindowDimensions();
        
        const loadingStyle = {
            display: this.state.loading ? 'block' : 'none',
            position:'fixed'
        };
        const offset = dims.x > 1040 ? 270 : 0;
        const left = (dims.x/2)-25+(offset/2);
        const top = (dims.y-80);

        let blockerStyle = null;

        if (this.state.loading) {
            blockerStyle = {
                width: '100%',
                height: '100%',
                position: 'absolute',
                display: 'block',
                zIndex: 20,
            };
        } 

        return (
            <div>
                <div className="block" style={blockerStyle}></div>

                <RefreshIndicator
                    {...this.props}
                    size={50}
                    left={left}
                    top={top}
                    loadingColor={"#FF9800"}
                    status="loading"
                    style={loadingStyle}
                    />
            </div>
        );
    }
}

export default Loading;


/** WEBPACK FOOTER **
 ** ./app-react/components/Loading.jsx
 **/